/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcCasesV1CaseQueryServiceCaseListCaseListRequest, IxcCasesV1CaseQueryServiceCaseListResponse } from '@interxfi/types';

export const IXC_CASES_V1_CASE_QUERY_SERVICE_CASE_LIST_AUDIENCE = ['clearing', 'program'];

export async function ixcCasesV1CaseQueryServiceCaseList(baseUrl: string | undefined, request?: IxcCasesV1CaseQueryServiceCaseListCaseListRequest, requestInit?: RequestInit): Promise<IxcCasesV1CaseQueryServiceCaseListResponse | undefined> { return makeRequest<IxcCasesV1CaseQueryServiceCaseListResponse, IxcCasesV1CaseQueryServiceCaseListCaseListRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/case/v1/case/q', request, requestInit)); }

